import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import apiHelpers from '@/utils/api'
import { AloDbFleet, isAloDbFleetCoverage, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import MissionDetailFileTransfer from '@/components/mission/MissionDetailFileTransfer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetDetailFileTransfer',
  props: {
    fleet: null,
    isleft: { type: Boolean },
    uiid: null,
    isVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  fleet: AloDbFleet
  isleft: boolean
  uiid: string
  isVisible: boolean
};



const fleetIco = computed(() => {
  return isAloDbFleetCoverage(props.fleet)
    ? 'mdi-select-group'
    : isAloDbFleetFormation(props.fleet)
    ? 'mdi-vector-circle'
    : 'mdi-multicast'
})

const missions = computed(
  () => props.fleet.activeMissionIds?.map(id => store.myGetters?.missionsById[id])?.filter(m => !!m) ?? [],
)

const gliders = computed(() => missions.value.map(m => ({ id: m.misId, libelle: m.gliKey })))

const configLastFile = computed(() => store.state.fleet.context?.configLastFile)

onMounted(() => {
  if (
    !store.state.fleet.context?.configLastFile ||
    store.state.fleet.context.configLastFile.idFleet != props.fleet.id
  ) {
    restoreConfigLastFile()
  }
})

const saving = ref(false)

function restoreConfigLastFile() {
  store.state.fleet.context.configLastFile = {
    enableCatchUpNav: true,
    enableCatchUpPld: true,
    nbDownLastNavFile: 1,
    nbDownLastPldFile: 1,
  }
}

async function applyToAll() {
  if (saving.value) return
  saving.value = true

  for (const mission of missions.value.filter(m => m.misActifOn)) {
    if (mission.gliId == null) return
    try {
      await store.myActions.GLIDER_IRIS_FILE_TRANSFERT_REQUEST(mission.gliId!)
      await store.myActions.GLIDER_UPDATE_MODIFIED_FILE_TRANSFERT({
        itemId: mission.gliId!,
        newProperties: {
          mod_settings: {
            FileTransfer_standard: {
              caught_old_file_nav: configLastFile.value.enableCatchUpNav,
              caught_old_file_sci: configLastFile.value.enableCatchUpPld,
              nb_file_nav: configLastFile.value.nbDownLastNavFile,
              nb_file_sci: configLastFile.value.nbDownLastPldFile,
            },
          },
        },
      })
      await store.myActions.GLIDER_IRIS_FILE_TRANSFERT_SAVE_REQUEST(mission.gliId!)
    } catch (e) {
      console.error(e)
    }
  }
  nextTick(() => {
    restoreConfigLastFile()
    saving.value = false
  })
}

function downloadFile(url: string) {
  apiHelpers.downloadFile(url, '.csv')
}

const selectedGliderIdx = ref(0)

return { __sfc: true,props, fleetIco, missions, gliders, configLastFile, saving, restoreConfigLastFile, applyToAll, downloadFile, selectedGliderIdx, store, MissionDetailFileTransfer }
}

})